import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { CreateBadgeRequest, DeleteBadgeRequest, UpdateBadgeRequest } from './badge.types';

export const requestCreateBadge = createAction<SagaPayload<CreateBadgeRequest>['payload']>('request/createBadge');

export const requestViewBadges = createAction('request/viewBadges');

export const requestUpdateBadge = createAction<SagaPayload<UpdateBadgeRequest>['payload']>('request/updateBadge');

export const requestDeleteBadge = createAction<SagaPayload<DeleteBadgeRequest>['payload']>('request/deleteBadge');
